'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "role", "ariaValueText"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { ProgressDot } from "./ProgressDot.mjs";
import { ProgressDotsSvg } from "./ProgressDotsSvg.mjs";
/**
 * ProgressDots is used to help end users understand the app is waiting for a response or loading data from the server.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-progressdots--docs) |
 * [Encore site](https://encore.spotify.net/web/components/progress-indicators#progress-dots) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/ProgressDots) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12341&t=608qKxXhWG8gyhvB-1)
 */
export var ProgressDots = /*#__PURE__*/React.forwardRef(function ProgressDots(_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'progressbar' : _ref$role,
    _ref$ariaValueText = _ref.ariaValueText,
    ariaValueText = _ref$ariaValueText === void 0 ? 'Loading' : _ref$ariaValueText,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(ProgressDotsSvg, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1 100",
    xmlSpace: "preserve",
    $size: size,
    role: role,
    "aria-valuetext": ariaValueText,
    ref: ref
  }, props, {
    "data-encore-id": ENCORE_DATA_IDS.ProgressDots
  }), /*#__PURE__*/React.createElement(ProgressDot, {
    stroke: "none",
    cx: "-140",
    cy: "50",
    r: "32"
  }), /*#__PURE__*/React.createElement(ProgressDot, {
    stroke: "none",
    cx: "0",
    cy: "50",
    r: "32"
  }), /*#__PURE__*/React.createElement(ProgressDot, {
    stroke: "none",
    cx: "140",
    cy: "50",
    r: "32"
  }));
});